import {
  Button,
  FormGroup,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import { useFormik } from "formik";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import { Container, ContainerForm, ContainerFormRight, Title } from "../../styles/index.sty";
import AlertSnack from "../../components/Alert/AlertSnack";
import { useAuth } from "../../context/authContext";
import { useLists } from "../../context/listContext";
import { insertProductData, updateProductData } from "../../api/products.api";
import { useEffect } from "react";

export const AddProduct = () => {
  const { config2 } = useAuth();
  const {
    fetchProductsList,
    productSubCategoriesByCatList,
    fetchProductSubCategoriesByCatList,
    productCategoriesByBarList,
    productCategoriesBarList,
    fetchProductCategoriesByBarList,
    fetchProductCategoriesBarList,
    colorsList, 
    fetchColorsList,
    materialsList, 
    fetchMaterialsList
    // brandsList,
  } = useLists();

  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);
  const prodData = location?.state?.data;
  const [product_category_id, setProduct_category_id] = useState(
    prodData?.product_category_id
  );
  const [product_category_bar_id, setProduct_category_bar_id] = useState(
    prodData?.product_category_bar_id
  );
  // const [brand_id, setBrand_id] = useState(prodData?.brand_id);
  const [product_sub_category_id, setProduct_sub_category_id] = useState(
    prodData?.product_sub_category_id
  );

  const [ dimensions, setDimensions ] = useState({
    length: prodData?.dimensions.split(/[ LHW*]+/)[0],
    width: prodData?.dimensions.split(/[ LHW*]+/)[1],
    height: prodData?.dimensions.split(/[ LHW*]+/)[2]
  });

  useEffect(() => {
    fetchProductCategoriesBarList();
    fetchProductCategoriesByBarList(prodData?.product_category_bar_id);
    fetchProductSubCategoriesByCatList(prodData?.product_category_id);
    fetchColorsList();
    fetchMaterialsList();
    console.log(prodData);
  }, [location])
  
  const [open, setOpen] = useState(false);
  const [response, setResponse] = useState({});
  const formik = useFormik({
    initialValues: {
      product_name: prodData?.product_name,
      product_description: prodData?.product_description,
      product_short_description: prodData?.product_short_description,
      product_overview: prodData?.product_overview,
      product_price: prodData?.product_price,
      color: prodData?.color,
      material: prodData?.material,
      product_offer_price: prodData?.product_offer_price,
      stock: prodData?.stock,
      product_warranty: prodData?.product_warranty,
      unit: prodData?.unit,
      discount_type: prodData?.discount_type
    },
    onSubmit: async (values) => {
      setLoading(true);
      if (prodData) {
        const submit = await updateProductData(
          {
            ...values,
            file,
            ...dimensions,
            product_id: prodData?.product_id,
            // brand_id,
            product_category_bar_id,
            product_category_id,
            product_sub_category_id,
          },
          config2
        );
        setResponse(submit);
        setOpen(true);
        fetchProductsList();
        if (submit.status === "success") {
          navigate("/products");
        }
      } else {
        const submit = await insertProductData(
          {
            ...values,
            file,
            ...dimensions,
            // brand_id,
            product_category_bar_id,
            product_category_id,
            product_sub_category_id,
          },
          config2
        );
        setResponse(submit);
        fetchProductsList();
        setOpen(true);
        if (submit.status === "success") {
          navigate("/products");
        }
      }
    },
  });

  return (
    <>
      <Container style={{margin: "1rem 0"}}>
        <Title variant="h5" className="w-[100%]">
          Enter Product Details.
        </Title>
        <ContainerForm>
          <div className="w-[100%]">
            {open && (
              <AlertSnack
                open={open}
                setOpen={setOpen}
                response={response}
                setLoading={setLoading}
                route="customers"
              />
            )}

            {loading ? (
              <div className="items-center">
                <BeatLoader color="#36d7b7" />
              </div>
            ) : (
              <div style={{ width: "80%", margin: "auto" }}>
                {/* <FormGroup>
                  <InputLabel id="demo-simple-select-label">Brand:</InputLabel>
                  <Select
                    id="demo-simple-select"
                    value={brand_id}
                    style={{ textAlign: "left" }}
                    onChange={(e) => {
                      setBrand_id(e.target.value);
                    }}
                  >
                    {brandsList.map((cat) => {
                      return (
                        <MenuItem value={cat.brand_id}>
                          {cat.brand_name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormGroup>
                <br /> */}
              <FormGroup>
                <InputLabel id="demo-simple-select-label">
                  Product Category Bar:<span className='text-[red]'>** </span>
                </InputLabel>
                <Select
                  id="demo-simple-select"
                  value={product_category_bar_id}
                  style={{ textAlign: "left" }}
                  onChange={(e) => {
                    setProduct_category_bar_id(e.target.value);
                    fetchProductCategoriesByBarList(e.target.value);
                  }}
                >
                  {productCategoriesBarList.map((bar) => {
                    return (
                      <MenuItem
                        value={bar.product_category_bar_id}
                        key={bar.product_category_bar_id}
                      >
                        {bar.product_category_bar_name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormGroup>
              <br />
                <FormGroup>
                  <InputLabel id="demo-simple-select-label">
                    Product Category:<span className='text-[red]'>** </span>
                  </InputLabel>
                  <Select
                    id="demo-simple-select"
                    value={product_category_id}
                    style={{ textAlign: "left" }}
                    onChange={(e) => {
                      setProduct_category_id(e.target.value);
                      fetchProductSubCategoriesByCatList(e.target.value);
                    }}
                  >
                    {productCategoriesByBarList.map((cat) => {
                      return (
                        <MenuItem value={cat.product_category_id}>
                          {cat.product_category_name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormGroup>
                <br />
                <FormGroup>
                  <InputLabel id="demo-simple-select-label">
                    Product Sub Category:<span className='text-[red]'>** </span>
                  </InputLabel>
                  <Select
                    id="demo-simple-select"
                    value={product_sub_category_id}
                    style={{ textAlign: "left" }}
                    onChange={(e) => {
                      setProduct_sub_category_id(e.target.value);
                    }}
                  >
                    {productSubCategoriesByCatList.map((sub_cat) => {
                      return (
                        <MenuItem value={sub_cat.product_sub_category_id}>
                          {sub_cat.product_sub_category_name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormGroup>
                <br />
                <FormGroup>
                  <InputLabel htmlFor="product_name">Product Name:<span className='text-[red]'>** </span> </InputLabel>
                  <OutlinedInput
                    name="product_name"
                    placeholder="Enter Product Name"
                    id="product_name"
                    type="text"
                    value={formik.values.product_name}
                    onChange={formik.handleChange}
                  />
                </FormGroup>
                <br />
                <FormGroup>
                  <InputLabel htmlFor="product_description">
                    Product Description:{" "}<span className='text-[red]'>** </span>
                  </InputLabel>
                  <OutlinedInput
                    name="product_description"
                    placeholder="Enter Product Description"
                    id="product_description"
                    type="text"
                    multiline
                    value={formik.values.product_description}
                    onChange={formik.handleChange}
                  />
                </FormGroup>
                <br />
                <FormGroup>
                  <InputLabel htmlFor="product_short_description">
                    Product Short Description:{" "}
                  </InputLabel>
                  <OutlinedInput
                    name="product_short_description"
                    placeholder="Enter Product Short Description"
                    id="product_short_description"
                    type="text"
                    multiline
                    value={formik.values.product_short_description}
                    onChange={formik.handleChange}
                  />
                </FormGroup>
                <br />
                <FormGroup>
                  <InputLabel htmlFor="product_overview">
                    Product Overview:{" "}
                  </InputLabel>
                  <OutlinedInput
                    name="product_overview"
                    placeholder="Enter Product Overview"
                    id="product_overview"
                    type="text"
                    multiline
                    value={formik.values.product_overview}
                    onChange={formik.handleChange}
                  />
                </FormGroup>
                <br />
                <FormGroup className="flex wrap w-1/1">
                  <InputLabel className="w-1/1" htmlFor="dimensions">
                    Product Dimensions:{" "}<span className='text-[red]'>** </span>
                  </InputLabel>
                  <div className="flex">
                    <OutlinedInput
                      className="w-1/3"
                      name="width"
                      placeholder="Width"
                      id="width"
                      type="text"
                      value={dimensions.width}
                      onChange={(e) => setDimensions(prev => ({...prev, width: e.target.value}))}
                      />
                    <OutlinedInput
                      className="w-1/3"
                      name="length"
                      placeholder="Length"
                      id="length"
                      type="text"
                      value={dimensions.length}
                      onChange={(e) => setDimensions(prev => ({...prev, length: e.target.value}))}
                    />
                    <OutlinedInput
                      className="w-1/3"
                      name="height"
                      placeholder="Height"
                      id="height"
                      type="text"
                      value={dimensions.height}
                      onChange={(e) => setDimensions(prev => ({...prev, height:  e.target.value}))}
                      />
                  </div>
                </FormGroup><br/>
                <FormGroup>
                  <InputLabel id="demo-simple-select-label">
                    Dimension Units:<span className='text-[red]'>** </span>
                  </InputLabel>
                  <Select
                    id="demo-simple-select"
                    value={formik.values.unit}
                    name="unit"
                    style={{ textAlign: "left" }}
                    onChange={formik.handleChange}
                  >
                        <MenuItem value="cms">CM(s)</MenuItem>
                        <MenuItem value="inch">Inch(es)</MenuItem>
                        <MenuItem value="mm">MM(s)</MenuItem>
                  </Select>
                </FormGroup>
                <br />
                <FormGroup>
                  <InputLabel htmlFor="file">Product Image:<span className='text-[red]'>** </span> </InputLabel>
                  <OutlinedInput
                    name="file"
                    placeholder="Select Image"
                    id="file"
                    type="file"
                    // value={file}
                    onChange={(e) => setFile(e.target.files[0])}
                  />
                </FormGroup>
                <br />
                <FormGroup>
                  <InputLabel htmlFor="product_price">
                    Product Price:{" "}<span className='text-[red]'>** </span>
                  </InputLabel>
                  <OutlinedInput
                    name="product_price"
                    placeholder="Enter Product Price"
                    id="product_price"
                    type="number"
                    value={formik.values.product_price}
                    onChange={formik.handleChange}
                  />
                </FormGroup>
                <br />
                <FormGroup>
                  <InputLabel htmlFor="product_offer_price">
                    Product Offer Price/ Discount:{" "}<span className='text-[red]'>** </span>
                  </InputLabel>
                  <OutlinedInput
                    name="product_offer_price"
                    placeholder="Enter Product Offer Price"
                    id="product_offer_price"
                    type="number"
                    value={formik.values.product_offer_price}
                    onChange={formik.handleChange}
                  />
                </FormGroup><br/>
                <FormGroup>
                  <InputLabel id="demo-simple-select-label">
                    Discount Type:<span className='text-[red]'>** </span>
                  </InputLabel>
                  <Select
                    id="demo-simple-select"
                    value={formik.values.discount_type}
                    name="discount_type"
                    style={{ textAlign: "left" }}
                    onChange={formik.handleChange}
                  >
                        <MenuItem value="%">%</MenuItem>
                        <MenuItem value="₹">₹</MenuItem>
                        <MenuItem value="none">None</MenuItem>
                  </Select>
                </FormGroup>
              <FormGroup>
                <InputLabel id="demo-simple-select-label">
                  Color:<span className='text-[red]'>** </span>
                </InputLabel>
                <Select
                  id="demo-simple-select"
                  name="color"
                  value={formik.values.color}
                  style={{ textAlign: "left" }}
                  onChange={formik.handleChange}
                >
                  {colorsList.map((color) => {
                    return (
                      <MenuItem
                        value={color.color_name}
                        key={color.color_name}
                      >
                        {color.color_name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormGroup>
              <br />
              <FormGroup>
                <InputLabel id="demo-simple-select-label">
                  Material:<span className='text-[red]'>** </span>
                </InputLabel>
                <Select
                  id="demo-simple-select"
                  name="material"
                  value={formik.values.material}
                  style={{ textAlign: "left" }}
                  onChange={formik.handleChange}
                >
                  {materialsList.map((material) => {
                    return (
                      <MenuItem
                        value={material.material_name}
                        key={material.material_name}
                      >
                        {material.material_name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormGroup>
              <br />
                <FormGroup>
                  <InputLabel htmlFor="stock">Stock:<span className='text-[red]'>** </span> </InputLabel>
                  <OutlinedInput
                    name="stock"
                    placeholder="Enter Stock"
                    id="stock"
                    type="number"
                    value={formik.values.stock}
                    onChange={formik.handleChange}
                  />
                </FormGroup>
                <br />
                <FormGroup>
                  <InputLabel htmlFor="product_warranty">Product Warranty:<span className='text-[red]'>** </span> </InputLabel>
                  <OutlinedInput
                    name="product_warranty"
                    placeholder="Enter Product Warranty"
                    id="product_warranty"
                    type="number"
                    value={formik.values.product_warranty}
                    onChange={formik.handleChange}
                  />
                </FormGroup>
                <div className="flex flex-row justify-between">
                  <Button
                    type="button"
                    variant="contained"
                    color="info"
                    onClick={() => navigate("/products")}
                    style={{
                      marginTop: "1rem",
                      width: "48%",
                    }}
                  >
                    Back
                  </Button>
                  <Button
                    type="button"
                    variant="contained"
                    color="info"
                    onClick={formik.handleSubmit}
                    style={{
                      marginTop: "1rem",
                      width: "48%",
                    }}
                  >
                    Save & Continue
                  </Button>
                </div>
              </div>
            )}
          </div>
        </ContainerForm>
        <ContainerFormRight>
          <div className="flex flex-wrap">
            <p className="text-2xl mb-4 w-[100%]">
              <b>Image Preview</b>
            </p>
            <hr />
            {location?.pathname.includes("update") ? (
              <div className="w-[50%] mb-12">
                <p className="text-xl mb-4">
                  <b>Old Image</b>
                </p>
                <img
                  className=" m-auto"
                  src={prodData?.product_image_file}
                  alt={prodData?.product_image_name}
                />
              </div>
            ) : null}
            <div className="w-[50%]">
              <p className="text-xl mb-4">
                <b>New Image</b>
              </p>
              {file ? (
                <img
                  className=" m-auto"
                  src={URL.createObjectURL(file)}
                  alt={prodData?.product_image_name}
                />
              ) : (
                <p>No Image Selected</p>
              )}
            </div>
          </div>
        </ContainerFormRight>
      </Container>
    </>
  );
};
